export default {
  i18n: {
    action: {
      delete: 'Delete',
      show: 'Show',
      list: 'List',
      save: 'Save',
      create: 'Create',
      edit: 'Edit',
      cancel: 'Cancel',
      refresh: 'Refresh',
      add_filter: 'Add filter',
      remove_filter: 'Remove this filter',
    },
    auth: {
      username: 'Username',
      password: 'Password',
      sign_in: 'Sign in',
      sign_in_error: 'Authentication failed, please retry',
      logout: 'Logout',
      forgot: 'Forgot your password?',
    },
    boolean: {
      true: 'Yes',
      false: 'No',
    },
    page: {
      list: '%{name}',
      edit: '%{name} #%{id}',
      show: '%{name} #%{id}',
      create: 'Create %{name}',
      delete: 'Delete %{name} #%{id}',
    },
    input: {
      image: {
        upload_several: 'Drop some files to upload, or click to select one.',
        upload_single: 'Drop a file to upload, or click to select it.',
      },
    },
    message: {
      yes: 'Yes',
      no: 'No',
      are_you_sure: 'Are you sure ?',
      about: 'About',
    },
    navigation: {
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      no_results: 'No results',
      next: 'Next',
      prev: 'Prev',
    },
    notification: {
      updated: 'Element updated',
      created: 'Element created',
      deleted: 'Element deleted',
      item_doesnt_exist: 'Element does not exist',
    },
    validation: {
      required: 'Required',
    },
  },
  app: {
    status: {
      'in-progress': 'In progress',
      processed: 'Processed',
    },
  },
}



// WEBPACK FOOTER //
// ./i18n/messages.js